import { render, staticRenderFns } from "./ageView.vue?vue&type=template&id=546f654e&scoped=true"
import script from "./ageView.vue?vue&type=script&lang=js"
export * from "./ageView.vue?vue&type=script&lang=js"
import style0 from "./ageView.vue?vue&type=style&index=0&id=546f654e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546f654e",
  null
  
)

export default component.exports